import "./index.css";

// Components Imports
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import CommonLayout from "../../_utils/CommonLayout";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import TEXT from "../../../utils/globalText";

const MISReportCreateConfirm = (props) => {
  const formateDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "long",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  // Field Sets
  const STATUS_FIELDS = new Set([
    TEXT.TRANSACTION_APPROVAL_STATUS,
    TEXT.TRANSACTION_DISTRIBUTION_STATUS,
    TEXT.ACCOUNT_STATUS,
  ]);

  const DATE_FIELDS = new Set([
    TEXT.ACCOUNT_STATEMENT_ENTRY_DATE,
    TEXT.APPROVED_ON,
    TEXT.CREATED_ON,
    TEXT.DISTRIBUTION_COMPLETION_DATE,
    TEXT.REJECTED_ON,
  ]);

  const EMAIL_FIELDS = new Set([
    TEXT.ADDITIONAL_RECIPIENT,
    TEXT.BENEFICIARY_ACCOUNT_EMAIL_ID,
  ]);

  const IFSC_FIELDS = new Set([
    TEXT.BENEFICIARY_ACCOUNT_IFSC,
    TEXT.OWNER_ACCOUNT_IFSC,
  ]);

  const ACCOUNT_NUMBER_FIELDS = new Set([
    TEXT.BENEFICIARY_ACCOUNT_NUMBER,
    TEXT.OWNER_ACCOUNT_NUMBER,
    TEXT.ACCOUNT_NUMBER,
  ]);

  const SPECIFIC_PLACEHOLDERS = {
    [TEXT.TRANSACTION_INITIATOR]: TEXT.TRANSACTION_INITIATOR,
    [TEXT.AMOUNT]: TEXT.AMOUNT,
    [TEXT.APPROVED_BY]: TEXT.APPROVED_BY,
    [TEXT.USERNAME]: TEXT.USERNAME,
    [TEXT.BENEFICIARY_ACCOUNT_NAME]: TEXT.ACCOUNT_NAME,
    [TEXT.ACCOUNT_NAME]: TEXT.ACCOUNT_NAME,
    [TEXT.BENEFICIARY_ACCOUNT_BANK_NAME]: TEXT.BANK_NAME,
    [TEXT.OWNER_ACCOUNT_BANK_NAME]: TEXT.BANK_NAME,
    [TEXT.BENEFICIARY_ACCOUNT_CREATED_COUNT]: TEXT.NUMBER_OF_ACCOUNTS_CREATED,
    [TEXT.BENEFICIARY_TRANSACTION_CREATED_COUNT]:
      TEXT.NUMBER_OF_TRANSACTIONS_CREATED,
    [TEXT.INTERNAL_TRANSACTION_CREATED_COUNT]:
      TEXT.NUMBER_OF_TRANSACTIONS_CREATED,
    [TEXT.BENEFICIARY_TRANSACTION_APPROVED_COUNT]:
      TEXT.NUMBER_OF_TRANSACTIONS_APPROVED,
    [TEXT.INTERNAL_TRANSACTION_APPROVED_COUNT]:
      TEXT.NUMBER_OF_TRANSACTIONS_APPROVED,
    [TEXT.OPENING_BALANCE]: TEXT.BALANCE,
    [TEXT.CLOSING_BALANCE]: TEXT.BALANCE,
    [TEXT.OWNER_ACCOUNT_TYPE]: TEXT.ACCOUNT_TYPE,
    [TEXT.BENEFICIARY_ACCOUNT_PAN]: TEXT.PAN_NUMBER,
    [TEXT.CATEGORY]: TEXT.CATEGORY,
  };

  const getFilterValueSubtitle = (columnName, selectedOption = "") => {
    if (!columnName) return TEXT.DETAIL;

    if (EMAIL_FIELDS.has(columnName)) return TEXT.EMAIL_ID;
    if (IFSC_FIELDS.has(columnName)) return TEXT.IFSC_CODE;
    if (ACCOUNT_NUMBER_FIELDS.has(columnName)) return TEXT.ACCOUNT_NUMBER;
    if (STATUS_FIELDS.has(columnName)) return TEXT.STATUS;
    if (DATE_FIELDS.has(columnName)) return TEXT.DATE;

    if (SPECIFIC_PLACEHOLDERS[columnName]) {
      return SPECIFIC_PLACEHOLDERS[columnName];
    }

    if (selectedOption === TEXT.USER) return TEXT.DETAIL;

    return TEXT.DETAIL;
  };

  const renderFilterValue = (columnName, inputValue) => {
    if (columnName === TEXT.AMOUNT) {
      return <FormatAmount price={inputValue} />;
    }

    if (columnName === TEXT.LABELS && Array.isArray(inputValue)) {
      return inputValue.filter(Boolean).join(", ");
    }

    if (typeof inputValue === "boolean") {
      return inputValue ? TEXT.YES : "No";
    }

    if (typeof inputValue === "string" || typeof inputValue === "number") {
      return linkIdentifier(inputValue);
    }

    return "";
  };

  const selectedColumns = props?.columnsData.filter((col) => col.selected);

  return (
    <>
      <div
        className={`Mis_report_Main_div px-padding-md Qmd:px-padding-base gap-x-gap-md Qsmd:mx-margin-xs mx-margin-base`}
      >
        <CommonLayout>
          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                {TEXT.FIELD}
              </p>

              <TitleSubtitlePair
                title={props?.selectedOption}
                subtitle={TEXT.FIELD}
                variant="md"
                titleColor="text-primary"
              />
            </div>
          </div>

          {props?.startDate && props?.endDate && (
            <div className="Mis_report_SelectAcc_div_confirm">
              <div className="flex flex-col gap-y-gap-md relative">
                <p className="font-semibold text-font-md text-text-primary">
                  {TEXT.DATE_RANGE}
                </p>

                <TitleSubtitlePair
                  title={`${formateDate(props?.startDate)} - ${formateDate(
                    props?.endDate,
                  )}`}
                  subtitle={TEXT.DATE_RANGE}
                  variant="md"
                  titleColor="text-primary"
                />
              </div>
            </div>
          )}

          <div className="Mis_report_SelectAcc_div_confirm">
            <div className="flex flex-col gap-y-gap-md relative">
              <p className="font-semibold text-font-md text-text-primary">
                {TEXT.COLUMNS}
              </p>
              <div>
                {selectedColumns.map((col, index) => (
                  <div key={col.columnId}>
                    <p className="font-normal text-font-md text-text-primary">
                      {col.columnName}
                    </p>

                    {index !==
                      selectedColumns.length -
                        GlobalConfiguration?.lengthCheckOne && (
                      <div className="border-t border-primary-bg my-margin-sm"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {props?.selectedValues?.dropdown1 !== "" &&
          props?.selectedValues?.dropdown2 !== "" ? (
            <div className="Mis_report_SelectAcc_div_confirm">
              <div className="flex flex-col gap-y-gap-md relative">
                <p className="font-semibold text-font-md text-text-primary">
                  Sort By{" "}
                  <span className="font-normal text-font-md  text-text-primary">
                    (Optional)
                  </span>
                </p>

                <div className="flex flex-col justify-between gap-y-gap-sm">
                  <TitleSubtitlePair
                    title={props?.selectedValues?.dropdown1}
                    subtitle={TEXT.COLUMN}
                    variant="md"
                    titleColor="text-primary"
                  />
                  <div className=" border-t-border border-primary-bg"></div>
                  <TitleSubtitlePair
                    title={props?.selectedValues?.dropdown2}
                    subtitle={TEXT.SORTING}
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="Mis_report_filter_name relative">
              <>
                <div className="w-full flex flex-col gap-gap-md h-fit">
                  <p className="font-semibold text-font-md  text-text-primary">
                    Sort By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <TitleSubtitlePair
                    title={TEXT.NOT_GIVEN}
                    subtitle={TEXT.SORT_BY}
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </>
            </div>
          )}

          {props?.filterMapping?.length >
          GlobalConfiguration?.lengthCheckZero ? (
            props?.filterMapping.map((col) => (
              <div
                className="Mis_report_SelectAcc_div_confirm"
                key={col?.columnId}
              >
                <div className="flex flex-col gap-y-gap-md relative">
                  <p className="font-semibold text-font-md text-text-primary tracking- mb-margin-xs">
                    Filter By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <div className="flex flex-col justify-between gap-y-gap-sm">
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {col?.column_name}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        {TEXT.COLUMN}
                      </p>
                    </div>
                    <div className=" border-t-border border-primary-bg"></div>
                    <div className="flex flex-col justify-between gap-y-gap-xs">
                      <p className="font-normal text-font-md text-text-primary ">
                        {col?.criteria_name}
                      </p>
                      <p className="font-normal text-font-xs  text-text-secondary">
                        {TEXT?.CRITERION}
                      </p>
                    </div>
                    {col?.column_name !== TEXT.CONFIDENTIAL_TRANSACTION &&
                      col?.column_name !== TEXT.CREDIT_DEBIT && (
                        <div className=" border-t-border border-primary-bg"></div>
                      )}
                    {col?.column_name !== TEXT.CONFIDENTIAL_TRANSACTION &&
                      col?.column_name !== TEXT.CREDIT_DEBIT && (
                        <div className="flex flex-col justify-between gap-y-gap-xs">
                          <p
                            className={`font-normal text-font-md text-text-primary ${
                              STATUS_FIELDS.has(col?.column_name) ||
                              col?.column_name === TEXT.CATEGORY
                                ? "first-letter:uppercase"
                                : ""
                            }`}
                          >
                            {renderFilterValue(
                              col?.column_name,
                              col.input_value,
                            )}
                          </p>

                          <p className="font-normal text-font-xs text-text-secondary">
                            {getFilterValueSubtitle(
                              col?.column_name,
                              props?.selectedOption,
                            )}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="Mis_report_filter_name relative">
              <>
                <div className="w-full flex flex-col gap-gap-md h-fit">
                  <p className="font-semibold text-font-md  text-text-primary">
                    Filter By{" "}
                    <span className="font-normal text-font-md  text-text-primary">
                      (Optional)
                    </span>
                  </p>
                  <TitleSubtitlePair
                    title={TEXT.NOT_GIVEN}
                    subtitle="Filter by"
                    variant="md"
                    titleColor="text-primary"
                  />
                </div>
              </>
            </div>
          )}
        </CommonLayout>
      </div>
    </>
  );
};

export default MISReportCreateConfirm;
